import { combineReducers } from '@reduxjs/toolkit';
import { activitiesService } from './activities/activitiesService';
import { authReducer } from './authSlice';
import { daysOffService } from './daysOff/daysOffService';
import { reportsService } from './reports/reportsService';
import { preferencesReducer } from './preferencesSlice';
import { profileReducer } from './profileSlice';
import { reportsActivitiesService } from './reports/reportsActivitiesService';
import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import { reportsReducer } from './reports/reportsSlice';
import { employeesService } from './employees/employeesService';
import { projectsService } from './projects/projectsService';
import { towersService } from './towers/towersService';
import { tasksService } from './tasks/tasksService';

const rootPersistConfig = {
  key: 'root',
  storage: storageSession,
  whitelist: ['profile', 'auth', 'preferences'],
};

export const rootReducer = combineReducers({
  auth: authReducer,
  preferences: preferencesReducer,
  profile: profileReducer,
  reports: reportsReducer,
  [daysOffService.reducerPath]: daysOffService.reducer,
  [activitiesService.reducerPath]: activitiesService.reducer,
  [reportsActivitiesService.reducerPath]: reportsActivitiesService.reducer,
  [reportsService.reducerPath]: reportsService.reducer,
  [employeesService.reducerPath]: employeesService.reducer,
  [projectsService.reducerPath]: projectsService.reducer,
  [towersService.reducerPath]: towersService.reducer,
  [tasksService.reducerPath]: tasksService.reducer,
});

export const persistedReducer = persistReducer(rootPersistConfig, rootReducer);
